<template>
  <div>
    <button
      @click="playAudio"
      v-if="audioSrc"
      :style="{ height: height + 'px', width: height + 'px', display: display ? 'inline-block' : 'none' }"
      class="audio-btn"
    >
      <audio>
        <source :src="audioSrc" type="audio/mp3" />
      </audio>
      <inline-svg
        id="speaker-svg"
        :src="require('../../assets/svg/play2.svg').default"
        class="speaker-svg"
        aria-label="My image"
      ></inline-svg>
    </button>
    <div class="noaudio" v-if="!audioSrc"></div>
  </div>
</template>

<script>
import "./audioBtn.scss";
import { audioService } from "../../services/audioService";
export default {
  name: "audio-btn",
  props: {
    urlId: {
      type: String | Number,
      require: true
    },
    height: {
      type: Number,
      default: 50
    },
    autoplay: {
      type: Boolean,
      deafult: false
    },
    idx: {
      type: Number,
      default: 0
    },
    display: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      audioSrc: "",
      isStop: null,
      showError: false
    };
  },
  created() {
    this.getAudio();
  },
  watch: {
    urlId() {
      if (this.idx) return;
      this.isStop = true;
      this.getAudio();
    },
    idx() {
      this.isStop = true;
      this.getAudio();
    },
    autoplay() {
      if (this.autoplay) this.playAudio();
    }
  },
  methods: {
    getAudio() {
      console.log(this.autoplay);
      if (this.urlId) {
        audioService.playAudio(this.urlId).then(async res => {
          const { sound_file } = await res.json();
          this.audioSrc = sound_file;
          if (this.autoplay && this.audioSrc) {
            // this.isStop = false;
            this.playAudio();
          }
        });
      } else {
        this.audioSrc = null;
      }
    },
    playAudio(ev) {
      if (ev) {
        ev.stopPropagation();
      }
      if (this.$store.getters.isPlaying) {
        setTimeout(() => {
        }, 1500);
      }
      const audio = new Audio(this.audioSrc);
      document.getElementById('speaker-svg').classList.add("is-playing")
      this.$store.commit("setIsPlaying", true)
      audio.play().then(this.$store.commit("setIsPlaying", false)).catch(e => {
        console.log(e);
        this.$store.commit("setError", e)
        this.$store.commit("setIsPlaying", false)
      })
      document.getElementById('speaker-svg').classList.remove("is-playing")
    }
  },
  updated() {
    console.log("audio is updated");
  },
  destroyed() {
    this.isStop = true;
  },
  components: {
  }
};
</script>

<style scoped>
.noaudio {
  min-width: 40px;
}
</style>



// WEBPACK FOOTER //
// audioBtn.vue?05f08874